import { useLocation } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';

import useFetch from "../../../hooks/useFetch";
import { urlGetByIdWorks, urlProduct } from "../../../helpers/urls";
import { FormEdit } from "./FormEdit";

export const EditWork = () => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const { data } = useFetch(urlGetByIdWorks + searchParams.get('id'));
    const { data: dataProduct } = useFetch(urlProduct, 'GET');

    return (
        <section className="section_formEstimate">
            {(data && dataProduct)
                ? <FormEdit data={data} dataProduct={dataProduct}/>
                : <CircularProgress />
            }
        </section>
    )
}